import React from "react";

import {
  FaExternalLinkAlt,
  FaPhoneAlt,
} from "react-icons/fa";

import Footer from "../Home/Footer";
import FormContact from "../Home/FormContact";

import useScrollToTop from "../../hooks/useScrollToTop";
import AuthIcons from "../../hooks/AuthIcons";

import {
  useUser,
} from "../../contexts/UserContext";

import LandingButton from "../../components/Button/LandingButton";

import AboutMonAppliClubTournoi from "./AboutMonAppliClubTournoi";
import DiaporamaTournoi from "./DiaporamaTournoi";

import TournamentHero from "./components/TournamentHero";
import TournamentQuickNav from "./components/TournamentQuickNav";

import {
  TOURNAMENT_DEMO_URL,
  TOURNAMENT_PHONE,
  TOURNAMENT_PHONE_LABEL,
} from "./data/tournamentProductData";

import {
  openExternalPage,
  scrollToTournamentSection,
} from "./utils/tournamentProductUtils";

const MonAppliClubTournoi = () => {
  useScrollToTop();

  const { user } = useUser();

  const handleDemoClick = () => {
    openExternalPage(
      TOURNAMENT_DEMO_URL,
    );
  };

  return (
    <div className="flex min-h-screen flex-col bg-white dark:bg-slate-950">
      {!user && <AuthIcons />}

      <main className="flex-grow">
        <TournamentHero
          onDemoClick={
            handleDemoClick
          }
        />

        <TournamentQuickNav
          onDemoClick={
            handleDemoClick
          }
        />

        <div id="tournoi-about">
          <AboutMonAppliClubTournoi
            onDemoClick={
              handleDemoClick
            }
          />
        </div>

        <div id="tournoi-pages">
          <DiaporamaTournoi />
        </div>

        {/* CTA commercial */}
        <section className="relative overflow-hidden border-y border-slate-200 bg-slate-50 py-16 dark:border-white/10 dark:bg-slate-900/50 sm:py-20">
          <div className="pointer-events-none absolute -left-24 top-0 h-72 w-72 rounded-full bg-orange-300/20 blur-3xl dark:bg-orange-500/10" />

          <div className="pointer-events-none absolute -right-24 bottom-0 h-72 w-72 rounded-full bg-blue-300/20 blur-3xl dark:bg-blue-500/10" />

          <div className="relative mx-auto max-w-5xl px-4 text-center sm:px-6">
            <div className="text-sm font-bold uppercase tracking-[0.18em] text-orange-500">
              Découvrir la solution
            </div>

            <h2 className="mt-4 text-3xl font-bold tracking-tight text-slate-950 sm:text-5xl dark:text-white">
              Préparez votre prochain tournoi avec une organisation plus fluide
            </h2>

            <p className="mx-auto mt-5 max-w-3xl text-base leading-8 text-slate-600 sm:text-lg dark:text-slate-300">
              Consultez l’application en ligne, demandez une présentation personnalisée ou échangeons sur le format de votre prochaine compétition.
            </p>

            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row sm:flex-wrap">
              <LandingButton
                variant="primary"
                onClick={
                  handleDemoClick
                }
              >
                Voir le site en ligne

                <FaExternalLinkAlt className="ml-2 text-xs" />
              </LandingButton>

              <LandingButton
                variant="secondary"
                onClick={() =>
                  scrollToTournamentSection(
                    "tournoi-contact",
                  )
                }
              >
                Demander une démonstration
              </LandingButton>

              <a
                href={`tel:${TOURNAMENT_PHONE}`}
                className="inline-flex min-h-12 items-center justify-center gap-2 rounded-full border border-slate-200 bg-white px-6 py-3 text-sm font-bold text-slate-900 shadow-sm transition hover:-translate-y-0.5 hover:border-orange-200 hover:bg-orange-50 hover:text-orange-600 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:hover:border-orange-400/30 dark:hover:bg-orange-500/10 dark:hover:text-orange-300"
              >
                <FaPhoneAlt />

                {TOURNAMENT_PHONE_LABEL}
              </a>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section
          id="tournoi-contact"
          className="bg-white py-16 dark:bg-slate-950 sm:py-20"
        >
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="mb-10 max-w-3xl">
              <div className="text-sm font-bold uppercase tracking-[0.18em] text-orange-500">
                Contact
              </div>

              <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-950 sm:text-5xl dark:text-white">
                Parlons de votre prochain tournoi
              </h2>

              <p className="mt-4 text-base leading-8 text-slate-600 sm:text-lg dark:text-slate-300">
                Expliquez-moi votre organisation, le nombre de tapis, les catégories prévues et vos besoins. Je pourrai vous présenter les fonctionnalités les plus adaptées.
              </p>
            </div>

            <FormContact />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default MonAppliClubTournoi;